import React from 'react'
import { Link } from 'react-router-dom'

import Navbar from '../../components/navbar'
import VideoModalTwo from '../../components/video-modal-two'
import TopCoworkingCity from '../../components/top-coworking-city'
import EventTab from '../../components/event-tab'
import BlogOne from '../../components/blog-one'
import PricingTwo from '../../components/pricing-two'
import Footer from '../../components/footer'

import bg1 from '../../assets/images/managment/01.jpg'
import about1 from '../../assets/images/ab01.jpg'
import about2 from '../../assets/images/ab02.jpg'
import about3 from '../../assets/images/ab03.jpg'
import about4 from '../../assets/images/ab04.jpg'
import client1 from '../../assets/images/client/01.jpg'

import {FiArrowRight} from '../../assets/icons/vander'

export default function IndexEventManagment() {
  return (
    <>
     <Navbar/> 
     <section className="bg-half-170 bg-light">
      <div className="container">
          <div className="container">
              <div className="row justity-content-center mt-5">
                  <div className="col-12">
                      <div className="title-heading text-center">
                          <h4 className="heading fw-bold mb-3">World biggest conference <br/> for event managment</h4>
                          <p className="para-desc mx-auto text-muted">Start work with Leaping. Build responsive, mobile-first projects on the web with the world's most popular front-end component library.</p>
                      </div>
                  </div>
                  <div className="col-12 mt-md-5 mx-auto">
                      <img src={bg1} className="img-fluid shadow rounded-5" alt=""/>
                      <VideoModalTwo/>
                  </div>
              </div>
          </div>
      </div>
    </section>

    <section className="section"> 
      <div className="container">
          <div className="row align-items-center">
              <div className="col-md-6">
                  <div className="row align-items-center">
                      <div className="col-lg-6 col-md-6 col-6">
                          <div className="row">
                              <div className="col-lg-12 col-md-12 spacing">
                                  <div className="card rounded border-0 overflow-hidden">
                                      <img src={about1} className="img-fluid" alt=""/>
                                  </div>
                              </div>

                              <div className="col-lg-12 col-md-12 spacing">
                                  <div className="card rounded border-0 shadow overflow-hidden">
                                      <img src={about2} className="img-fluid" alt=""/>
                                  </div>
                              </div>
                          </div>
                      </div>

                      <div className="col-lg-6 col-md-6 col-6">
                          <div className="row">
                              <div className="col-lg-12 col-md-12 spacing">
                                  <div className="card rounded border-0 shadow overflow-hidden">
                                      <img src={about3} className="img-fluid" alt=""/>
                                  </div>
                              </div>

                              <div className="col-lg-12 col-md-12 spacing">
                                  <div className="card rounded border-0 shadow overflow-hidden">
                                      <img src={about4} className="img-fluid" alt=""/>
                                  </div>
                              </div>
                          </div>
                      </div>
                  </div>
              </div>

              <div className="col-md-6 mt-4 mt-sm-0 pt-2 pt-sm-0 ps-lg-4">
                  <div className="section-title">
                      <h5 className="text-primary">Event Organisation</h5>
                      <h4 className="title mb-4">Conference, <br/> Seminars & Event</h4>
                      <p className="text-muted para-desc">Build responsive, mobile-first projects on the web with the world's most popular front-end component library.</p>
                      <p className="text-muted">It seems that only fragments of the original text remain in the Lorem Ipsum texts used today. One may speculate that over the course of time certain letters were added or deleted at various positions within the text. This might also explain why one can now find slightly different versions. Due to the age of the Lorem Ipsum text there are no copyright issues to contend with.</p>
                      <div className="mt-4">
                          <Link to="#" className="btn btn-primary">Read More <i className="mdi mdi-chevron-right"></i></Link>
                      </div>
                  </div>
              </div>
          </div>
      </div>
    </section>

    <section className="section bg-light">
      <div className="container">
          <div className="row align-items-end mb-lg-4 pb-lg-2">
              <div className="col-lg-5">
                  <div className="section-title mb-4 pb-2 mb-lg-0 pb-lg-0 text-center text-lg-start">
                      <h4 className="title mb-4">Top Co-working Cities</h4>
                      <p className="text-muted para-desc ms-lg-auto mx-auto mb-0">Start work with Leaping. Build responsive, mobile-first projects on the web with the world's most popular front-end component library.</p>
                  </div>
              </div>

              <div className="col-lg-7 d-none d-lg-block">
                  <div className="text-center text-lg-end">
                      <Link to="#" className="btn btn-primary">See More <FiArrowRight className="fea icon-sm"/></Link>
                  </div>
              </div>
          </div>

         <TopCoworkingCity/>
          <div className="row justify-content-center d-lg-none d-block">
              <div className="col-12 text-center mt-4 pt-2">
                  <Link to="#" className="btn btn-primary">See More <FiArrowRight className="fea icon-sm"/></Link>
              </div>
          </div>
      </div>x
    </section>

    <section className="section">
        <div className="container">
            <div className="row align-items-end mb-4 pb-4">
                <div className="col-md-8">
                    <div className="section-title text-center text-md-start">
                        <h4 className="title mb-4">Our Latest Works And Projects</h4>
                        <p className="text-muted mb-0 para-desc">Start work with Leaping. Build responsive, mobile-first projects on the web with the world's most popular front-end component library.</p>
                    </div>
                </div>

                <div className="col-md-4 mt-4 mt-sm-0">
                    <div className="text-center text-md-end">
                        <Link to="#" className="text-primary">View more suggesions <FiArrowRight className="fea icon-sm"/></Link>
                    </div>
                </div>
            </div>
            <EventTab/>
        </div>

        <div className="container mt-100 mt-60">
            <div className="row justify-content-center">
                <div className="col-lg-8 col-md-10">
                    <div className="text-center">
                        <h1 className="display-2"><i className="mdi mdi-format-quote-open text-primary"></i></h1>
                        <p className="text-muted h5 fst-italic">" It seems that only fragments of the original text remain in the Lorem Ipsum texts used today. The most well-known dummy text is the 'Lorem Ipsum', which is said to have originated in the 16th century. "</p>

                        <div className="mt-4">
                            <img src={client1} className="img-fluid avatar avatar-small rounded-circle shadow" alt=""/>
                            <h6 className="text-primary mt-3 mb-0">Thomas Israel</h6>
                            <small className="text-muted">C.E.O</small>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section>

    <section className="section bg-light">
        <div className="container">
            <div className="row">
                <div className="col-12 text-center">
                    <div className="section-title mb-4 pb-2">
                        <h4 className="title mb-4">Choose A Ticket</h4>
                        <p className="text-muted para-desc mx-auto mb-0">Build responsive, mobile-first projects on the web with the world's most popular front-end component library.</p>
                    </div>
                </div>
            </div>
            <PricingTwo/>
        </div>
    </section>

    <section className="section">
        <div className="container mt-60">
            <div className="row">
                <div className="col-12 text-center">
                    <div className="section-title mb-4 pb-2">
                        <h4 className="title mb-4">Latest Blog & News</h4>
                        <p className="text-muted para-desc mx-auto mb-0">Build responsive, mobile-first projects on the web with the world's most popular front-end component library.</p>
                    </div>
                </div>
            </div>
            <BlogOne/>
        </div>
    </section>
    <Footer/>
    </>
  )
}
